import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=cb7f0e84&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=ts&"
export * from "./SystemMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=cb7f0e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f0e84",
  null
  
)

export default component.exports